<template>
    <div class="box">
		<PageHeader @back="goback" :content="'数据报表'" />
        <div class="content-box">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="访员姓名">
                    <el-input size="medium" v-model="searchForm.name" placeholder="请输入访员姓名"></el-input>
                </el-form-item>
                <el-form-item label="样本编号">
                    <el-input size="medium" v-model="searchForm.number" placeholder="请输入样本编号"></el-input>
                </el-form-item>
                <el-form-item label="样本状态">
                    <el-select 
                        size="medium"
                        v-model="searchForm.state"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in sampleStateList"
                            :key="item.value"
                            :label="item.label" 
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="medium" type="primary" @click="onSerach">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                border
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="auditName"
                    label="审核人姓名"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="interviewerName"
                    label="访员姓名">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="sampleId"
                    label="样本编号"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    label="是否通过"
                >
                    <template slot-scope="scope">
                        <!-- 待完成 -->
                        <el-tag v-if="scope.row.auditState == 0">未审核</el-tag>
                        <el-tag v-else-if="scope.row.auditState == 1" type="success">通过</el-tag>
                        <el-tag v-else-if="scope.row.auditState == 2" type="warning">未通过</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="auditTime"
                    label="时间">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="备注">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="top">
                            <span>{{scope.row.remark}}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                    width="200"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" v-if="scope.row.auditState == 2" type="primary" @click="approved(scope.row)">审核通过</el-button>
                        <el-button size="mini" v-if="scope.row.auditState == 1" type="danger" @click="auditFailed(scope.row)">审核失败</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-box">
                <el-pagination
                    :current-page="pageIndex"
                    :page-size="10"
                    background
                    layout="prev, pager, next"
                    :total="totals"
                    @current-change="handleCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
        
        <!-- 审核失败备注 -->
        <el-dialog
            title="备注"
            :visible.sync="reviewRemarks"
            width="30%"
            :before-close="handleCloseNote" :close-on-click-modal="false">
            <el-input
                type="textarea"
                :rows="6"
                placeholder="请编辑审核不通过原因"
                resize="none"
                v-model="noteValue">
            </el-input>
            <span slot="footer" class=" remarks-dialog-footer dialog-footer">
				<el-checkbox v-model="isCallBack">允许访员回拨补录</el-checkbox>
				<div>
                <el-button size="medium" @click="noteClearing">取 消</el-button>
                <el-button size="medium" type="primary" @click="OKnote">确 定</el-button>
					</div>
            </span>
			
        </el-dialog>
    </div>
</template>

<script>
import PageHeader from '@/components/pageHeader.vue';
export default {
    name: 'AuditReport',
    components: {
        PageHeader
    },
    data(){
        return{
            isCallBack: false, // 是否允许访员回拨补录
            tableData: [
                {
                    id: 1,
                    name: '审核员1',
                    fname: '访员1',
                    nunmber: '01',
                    state: 1,
                    date: 1,
                    beizhu: 1,
                },
                {
                    id: 2,
                    name: '审核员1',
                    fname: '访员1',
                    nunmber: '01',
                    state: 1,
                    date: 1,
                    beizhu: 1,
                },
            ],
            searchForm: {
                name: '',
                number: '',
                state: ''
            },
            sampleStateList: [
                {
                    value: '',
                    label: '全部'
                },
                {
                    value: 0,
                    label: '待审核'
                },
                {
                    value: 1,
                    label: '通过'
                },
                {
                    value: 2,
                    label: '未通过'
                }
            ],
            pageIndex: 1,
            totals: 0,
            reviewRemarks: false,
            noteValue: ''
        }
    },
    computed: {
        wid() {
            return sessionStorage.getItem('wid') || 0
        }
    },
    created() {
        if (!this.wid) {
            this.goBack()
        } else {
            this.getData()
        }
    },
    methods: {
        getData(){
            let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAduitsampleHistory}`,
				method: 'POST',
                data: {
                    qid: this.wid,
                    currentPage: this.pageIndex, // 当前页
                    pageSize: 10, // 每页多少条
                    sampleCode: this.searchForm.number,
                    auditState: this.searchForm.state,
                    userId: this.searchForm.name,
                },
				cb(res) {
					if (res.code == 0) {
						// 获取列表
                        that.tableData = res.resultBody.records
                        that.totals = res.resultBody.total
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
        },
        handleCurrentChange(e){
            this.pageIndex = e
            this.getData()
        },
        goBack() {
            this.$router.go(-1)
        },
        onSerach() {
            // 查询接口
            this.getData()
        },
        approved(item) {
            // 审核接口
            this.auditApi(1, item)
        },
        auditFailed(item) {
            this.activeAudit = item
            this.reviewRemarks = true
        },
        auditApi(state, item) {
            console.log(this.userId)
			let isCallBack = this.isCallBack == true ? 1 : 0;
            let that = this
            let params = {
				that: this,
				url: `${this.$config.service.resetAduitsampleHistory}`,
				method: 'POST',
                data: {
                    qid: this.wid,
                    id: item.id, // 样本编号
                    auditState: state, // 样本状态
                    remark: this.noteValue ,
					isCallBack: state == 2 ? isCallBack : ''
                },
				cb(res) {
                    console.log(res)
					if (res.code == 0) {
                        that.$message({
                            message: res.message,
                            type: 'success'
                        });
                        that.noteValue = ''
                        that.reviewRemarks = false

                        that.getData()
					} else {
                        that.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
				}
			};
			this.$util.request(params);
        },
        handleCloseNote() {
            this.noteValue = ''
            this.reviewRemarks = false
        },
        noteClearing(){
            this.noteValue = ''
            this.reviewRemarks = false
        },
        OKnote() {
            this.auditApi(2,this.activeAudit)
        },
    }
}
</script>

<style lang="scss" scoped>
    .box{
        width: 100%;
    }
    .page-header{
        padding: 24px;
        background-color: #fff;
        border-radius: 5px 5px 0 0;
    }
    .content-box{
        padding: 24px;
        border-radius: 0 0 5px 5px;
        background-color: #fff;
    }
    .page-box{
        margin-top: 20px;
        text-align: right;
    }
	.remarks-dialog-footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>